import { axios } from '@/utils/request'
// 获取所有标签
export function getStockSkuCategory(params) {
  return axios({
    url: '/frontend/stockSkuCategory',
    method: 'GET',
    params
  })
}

// 获取所有标签
export function getStockSkuCategoryNoPer() {
  return axios({
    url: '/frontend/stockSkuCategory',
    method: 'GET'
  })
}
// 获取素材组合配置素材组合数量
export function getUserConfigBatchDesign() {
  return axios({
    url: '/distribution/userConfig/batchDesign',
    method: 'GET'
  })
}
// 更改素材组合配置素材数量
export function setUserConfigBatchDesign(data) {
  return axios({
    url: '/distribution/userConfig/batchDesign',
    method: 'PUT',
    data
  })
}
// 保存批量设计
export function saveGruopDesignApi(data) {
  return axios({
    url: '/distribution/batchDesign',
    method: 'POST',
    data
  })
}

// 查找已设计
export function getDesignedMaterials(params) {
  return axios({
    url: '/distribution/product/getDesigned',
    method: 'GET',
    params
  })
}
// 获取产品名称、标签规则配置
export function getNameRule() {
  return axios({
    url: '/distribution/userConfig/nameRule',
    method: 'GET'
  })
}
// 修改产品名称、标签规则配置
export function setNameRule(data) {
  return axios({
    url: '/distribution/userConfig/setNameRule',
    method: 'POST',
    data
  })
}
